import { render, staticRenderFns } from "./_not-found.vue?vue&type=template&id=66be910d&"
import script from "./_not-found.vue?vue&type=script&lang=js&"
export * from "./_not-found.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports